// @flow

import { isProd } from './config';

declare var _learnq: {
  push: Function;
};

export const KlaviyoEvents = Object.freeze({
  ENTERED_WORK_HISTORY: 'Entered Work History',
  UPLOADED_RESUME: 'Uploaded Resume',
  ENTERED_EXPERIENCE_OR_LICENSE: 'Entered Experience or License',
  CLICKED_ENTER_A_JOB: 'Click Enter a Job',
  VIEWED_WORKFLOW_STEP: 'Viewed Workflow Step',
});

class KlaviyoTracker {
  identifyUser = (email: string, firstName: string, lastName: string) => {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[mock] Klaviyo Identify: ${email}, ${firstName} ${lastName}`);
      return;
    }
    const data = {
      $email: email,
      $first_name: firstName,
      $last_name: lastName,
    };
    _learnq.push(['identify', data]);
  };

  /*
  This should NOT be used for any flow-critical events. Ad blockers sometimes
  block the Klaviyo script making these events unreliable on the client-side. Log
  any critical events on the server-side and only use this for basic usage tracking.
   */
  trackEvent = (event: string, data: any) => {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[mock] Klaviyo Track: ${event}`, data);
      return;
    }
    _learnq.push(['track', event, data]);
  };
}

export const KlaviyoTracking = {
  application: new KlaviyoTracker(),
};
